module.exports = __webpack_public_path__ + "static/img/赛事介绍_53.f62b80b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/赛事介绍_53.png
// module id = Qq/9
// module chunks = 6